export default "__VITE_ASSET__BJ7lmfqt__"